import { render } from "./NotFoundComponent.vue?vue&type=template&id=273a5e72&scoped=true&ts=true"
import script from "./NotFoundComponent.vue?vue&type=script&lang=ts"
export * from "./NotFoundComponent.vue?vue&type=script&lang=ts"

import "./NotFoundComponent.vue?vue&type=style&index=0&id=273a5e72&lang=sass&scoped=true"
/* custom blocks */
import block0 from "./NotFoundComponent.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-273a5e72"]])

export default __exports__